import { isEmpty } from 'lodash-es';
import { propOr } from 'ramda';
import { useBonusesStore } from '../../store';

const selectBsWagerBonus = () => propOr({}, 'bsWagerBonus');
export const useIsBsWagerBonusActive = () => {
  const bsWagerBonus = useBonusesStore(selectBsWagerBonus());

  return !isEmpty(bsWagerBonus);
};
